export default __webpack_public_path__ + "static/media/sports-end.e2a077fb.jpg";